import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScreenResolver from "./pages/ScreenResolver";
import { login } from "./services/authService";
import {
  setAuthToken,
  hydrateTokensFromStorage,
  startAutoRenewAll,
} from "./services/apiClient";

import "./index.css";

function App() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    hydrateTokensFromStorage();

    const doLogin = async () => {
      try {
        const USERNAME = process.env.REACT_APP_USERNAME;
        const PASSWORD = process.env.REACT_APP_PASSWORD;
        const TENANT_ID = process.env.REACT_APP_TENANT_ID;

        const apiTokenLS = localStorage.getItem("apiAuthToken");
        const adminTokenLS = localStorage.getItem("adminAuthToken");

        if (!apiTokenLS || !adminTokenLS) {
          const [apiData, adminData] = await Promise.all([
            login(USERNAME, PASSWORD, TENANT_ID, false),
            login(USERNAME, PASSWORD, TENANT_ID, true),
          ]);
          if (apiData?.token) setAuthToken(apiData.token, false);
          if (adminData?.token) setAuthToken(adminData.token, true);
        }

        startAutoRenewAll();
      } catch (err) {
        console.error("Auto-login failed:", err?.response?.data || err?.message);
        startAutoRenewAll();
      } finally {
        setIsReady(true);
      }
    };

    doLogin();
  }, []);

  if (!isReady) {
    return (
      <div className="flex justify-center items-center h-screen text-xl font-bold">
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* ✅ Standard Route: Matches any publicId (e.g., /69) */}
        <Route path="/:publicId" element={<ScreenResolver />} />
      </Routes>
    </Router>
  );
}

export default App;